module.exports = __webpack_public_path__ + "static/img/produto_g.185ff01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana-zero/produto_g.png
// module id = /Ugf
// module chunks = 0